import { Plugin } from "@nuxt/types";

/**
 * Fetch plugin.
 *
 * Executes store "fetch", to fetch initial data.
 *
 * @param {Context} context Nuxt context
 */
const plugin: Plugin = context => {
    context.app.$accessor.fetch();
    setInterval(async () => await context.app.$accessor.fetch(), 60000);
};

export default plugin;
